<template>
  <div class='EnbSuggestion'>
    <div class="label">Você pode gostar...</div>
    <div class="cont-itens">
      <component
      :is="!Prefes.componentModel03Prod ? 'EnbProduto' : Prefes.componentModel03Prod.name"
      v-for="(i, key) in produtos"
      :key="key"
      :data="i"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnbProduto from '../Produto/EnbProduto'
import EnbProduto02 from '../Produto02/EnbProduto02'

export default {
  name: 'EnbSuggestion',
  components: { EnbProduto, EnbProduto02 },
  data () {
    return {
      currentThemeProd: 'EnbProduto',
      produtos: []
    }
  },
  computed: {
    ...mapGetters(['Prefes', 'ItemSelected01'])
  },
  methods: {
    ...mapActions(['GetSuggestion'])
  },
  created () {
    this.GetSuggestion({ category: this.ItemSelected01.categoria, prodid: this.ItemSelected01.id })
      .then(res => this.produtos = res)
  }
}
</script>

<style scoped>
.EnbSuggestion {
  width: 96%;
  padding: 2%;
}

.label {
  font-size: 20px;
  padding-bottom: 2%;
}

.cont-itens {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: auto;
}

@media (max-width: 500px) {
  .cont-itens {
    width: 100%;
    flex-wrap: wrap;
    overflow: auto;
    padding-top: 5%;
    padding-bottom: 20%;
  }
}
</style>
